import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { TeacherVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { retrieveTeacherProfile } from "./retrieve-teacher";

const initialState: RetrievalState<TeacherVM | null> = { fetching: "idle", data: null };

export const retrieveTeacherProfileReducer = createReducer<RetrievalState<TeacherVM | null>>(initialState, builder => {
  builder.addCase(retrieveTeacherProfile.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveTeacherProfile.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveTeacherProfile.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
